import i18n from "i18next";
import { initReactI18next } from "react-i18next";
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        //Login
        "Mật khẩu": "Password",
        "Tên đăng nhập": "Username",
        "Ghi nhớ": "Memorize",
        "Quên mật khẩu": "Forgot password",

        "HỖ TRỢ KẾT NỐI PHẦN MỀM": "SOFTWARE CONNECTION SUPPORT",
        "Xin hãy điền tên đăng nhập.": "Please enter your username.",
        "Xin hãy điền mật khẩu.": "Please enter your password.",
        //Menu translate
        "Đăng tin bài": "Post",
        "Ưu đãi": "Deals",
        "Tin tức an ninh": "Cybersecurity news",
        "Quản lý tài khoản": "Account manager",
        "Quản lý cửa hàng Bkav": "Bkav store manager",
        "Bản quyền": "Lincense",
        "Cấu hình menu": "Menu configuration",
        "Đăng xuất": "Logout",
        // Info Lincense
        "Tên khách hàng": "Customer name",
        "Địa chỉ": "Address",
        "Điện thoại": "Phone number",
        "Ngày hết hạn": "Expiration date",
        "Mã đăng ký": "Registration code",
        "Gia hạn": "Extend",
        // Shop bkav
        "Danh mục sản phẩm": "Product portfolio",
        "Phần mêm diệt virus": "Antivirus software",
        "Điện thoại thông minh": "Smartphone",
        //other
        "Tìm kiếm": "Search",
        "Xin chào": "Hi",
        Gửi: "Send",
        "Ngôn ngữ": "Language",
        "Tiếng Việt": "Vietnamese",
        // title
        "Thêm mới tin tức an ninh": "Add a new security news",
        "Thêm mới bài viết ưu đãi": "Add a new offers",
        "Chi tiết sản phẩm": "Product details",
        "Chỉnh sửa tin tức an ninh": "Editing security news",
        "Chỉnh sửa sản phẩm": "Editing product",
        "Thông báo": "Notification",
        "Thêm Tab": "Add Tab",
        "DANH SÁCH MENU": "LIST MENU",
        "CẤU HÌNH MENU": "CONFIGURATION MENU",
        //Modal
        "Bạn có đồng ý xóa bài viết không?": "Do you agree to delete the post?",
        "Chỉnh sửa bài viết ưu đãi": "Edit offer",
        "Vô hiệu hóa tài khoản": "Deactivate the account",
        "Bạn có đồng ý khôi phục tài khoản":
          "Do you want to recover your account",
        "Khôi phục tài khoản": "Recover account",
        "Tiêu đề": "Title",
        "Lịch sử thay đổi": "History of change",
        "Ngày thực hiện": "Implementation date",
        "Nội dung thay đổi": "Content changes",
        "Người thực hiện": "Executor",
        "Chỉnh sửa tài khoản": "Edit account",
        "Mật khẩu mới": "New password",
        "Nhập lại mật khẩu mới": "Confirm new password",
        "Phân quyền": "Authorization",
        "Mô tả": "Descriptions",
        "Nội dung": "Content",
        "Đặt ảnh bài viết": "Avatar",
        "Chọn tệp": "Choose file",
        "Đối tượng hiển thị": "Objects displayed",
        Lưu: "Save",
        "Chi tiết bài viết": "Article details",
        "Tên file": "File name",
        "Nội dung trống": "Empty content",
        "Thêm mới tài khoản": "Add new account",
        "Xóa bài viết": "Delete post",
        "Xóa tài khoản": "Delete the account",
        "Bạn có đồng ý vô hiệu hóa tài khoản": "Do you want to block ",
        "không?": "?",
        "Thêm loại sản phẩm": "More product categories",
        "Tên loại sản phẩm": "Product type name",
        "Viết bài": "Post",
        "Nhập link": "Enter link",
        // notify
        "Bạn có đồng ý xóa sản phẩm này không?":
          "Do you want to delete this product?",
        "Bạn có đồng ý xóa tài khoản": "Do you want to delete account",
        "Thêm bài viết thành công": "Post successful",
        "Số lượng khách hàng trống": "Number of empty customers",
        "Số lượng không đúng!": "Incorrect quantity!",
        "Không tìm thấy kết quả": "No results were found",
        //modal add product

        "Đơn giá": "Price",
        "Giảm giá (%)": "Discount (%)",
        "Loại sản phẩm": "Product Type",
        "Mã sản phẩm": "Product code",
        "Tên sản phẩm": "Product name",
        "Ảnh sản phẩm": "Product image",
        "Thêm sản phẩm": "Add product",

        // Button
        "Thêm tab": "Add tab",
        "Đăng bài viết": "Post news",
        "Đăng nhập": "Login",
        "Thêm mới": "Add new",
        "Tạo tài khoản": "Create Account",
        "Hủy bỏ": "Cancel",
        "Đồng ý": "Ok",
        "Đăng sản phẩm": "Post Product",
        "Thêm vào menu": "Add to menu",
        //table
        "Người tạo": "Creator",
        "Thời gian": "Time",
        "Chức năng": "Actions",
        "Trạng thái": "Status",
        Quyền: "License",
        "Đang kích hoạt": "Active",
        "Không kích hoạt": "Inactive",
        "Tình trạng": "Status",
        "Hết hàng": "Out of stock",
        "Còn hàng": "Stocking",
        "Giá ưu đãi": "Price after offer",
        "Phạm vi": "Limit",
        "Thời gian bắt đầu KM": "Promotion start time",
        "Thời gian kết thúc KM": "Promotion end time",
        "Thời gian tạo": "Time create",
        //response
        "Username đã tồn tại": "User already exists",
        "Mật khẩu không đúng định dạng": "Incorrect password format!",
        //label
        "Kéo thả từng mục theo thứ tự bạn muốn sắp xếp:":
          "Drag and drop each item in the order you want to sort:",
        "Số lượng": "Quantity",
        "Chưa diễn ra": "Not happen",
        "Kết thúc": "Finish",
        "Đang diễn ra": "Happenning",
        "Tên tài khoản": "Username",
        "Thời gian bắt đầu": "Time start",
        "Thời gian kết thúc": "Time end",
        "Phạm vi hiển thị": "Limit",
        Nhóm: "Group",
        "Tất cả": "All",
        năm: " year",
        tháng: "month",
        "Tên tab": "Name tab",
        "Chọn icon": "Choose icon",
        "Giao diện hiển thị": "Display interface",
        "file có định dạng .svg": "file format is .svg",

        //select
        "Người dùng": "User",
        "Quản trị viên": "Administrators",

        //placeholder
        "Nhập số lượng": "Enter quantity",
        "Nhập nội dung bài viết": "Enter the content of the article",
        "Nhập tiêu đề bài viết": "Enter title",
        "Nhập mô tả": "Enter descriptions",
        "Nhập loại sản phẩm": "Enter product type",
        "Nhập giá sản phẩm": "Enter product price",
        "Nhập mã sản phẩm": "Enter product code",
        "Nhập giá ưu đãi": "Enter deals price",
        "Chọn thời gian": "Select time",
        "Tìm kiếm theo tiêu đề": "Search by title",
        "Nhập tên tab": "Enter name tab",
        "Nhập tên Tiếng Anh của tab": "Enter the English name of the tab",
        "Đăng nhập thất bại": "Login failed!",
        "Tên đăng nhập không được để trống.": "Username cannot be blank.",
        "Mật khẩu không được để trống.": "Password can not be blank.",
      },
    },
    vn: {
      translation: {
        "Attract group already exists": "Nhóm khách hàng đã tồn tại",
        "Incorrect password format": "Mật khẩu không đúng định dạng",
        "User already exists": "Tài khoản đã tồn tại",
        "login failed!": "Đăng nhập thất bại. Vui lòng thử lại",
        "Product code is exist": "Mã sản phẩm đã tồn tại",
        "User has been blocked": "Tài khoản đã bị vô hiệu hóa",
        "Duplicate menu tab name VN": "Tên tab bằng tiếng việt đã tồn tại",
        "Old password is incorrect": "Mật khẩu cũ không chính xác",
        "Duplicate router":
          "Trang điều hướng đã tồn tại. Vui lòng chọn điều hướng khác.",
      },
    },
  },
  lng: "vn",
  fallbackLng: "vn",
  interpolation: {
    escapeValue: false,
  },
});
export default i18n;
